import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faRss } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
  return (
    <div className="Footer-wrapper">
      <Row className="logo-row">
        <Col>
          <Container fluid className="Footer1">
            <a href="https://www.mathematica.org/">
              <img id="logo-tagline_white" src="./images/logo-tagline-white@2x.png" alt="MPR-logo-tagline" />
            </a>
          </Container>
        </Col>
      </Row>
      <Row className="cr-other-links-row">
        <Col>
          <Container fluid className="Footer2">
            <Row>
              <Col  
                xs={12}
                sm={12}
                md={3}
                lg={3}
                >
                <div className="copyright">
                  <span id="cr-text">© 2022 Mathematica</span>
                </div>
              </Col>
              <Col
                xs={{span: 12, offset: 0}} 
                sm={{span: 12, offset: 0}} 
                md={{span: 2, offset: 5}} 
                lg={{span: 2, offset: 6}}
                >
                <div className="social-media-icons">
                  <a href="https://twitter.com/MathematicaNow">
                    <FontAwesomeIcon icon={faTwitter} fixedWidth inverse size='lg' />
                  </a>
                  <a href="https://www.facebook.com/MathematicaNow/">
                    <FontAwesomeIcon icon={faFacebookF} fixedWidth inverse size='lg' />
                  </a>
                  <a href="https://www.linkedin.com/company/mathematica-/">
                    <FontAwesomeIcon icon={faLinkedinIn} fixedWidth inverse size='lg' />
                  </a>
                  <a href="https://www.instagram.com/mathematicanow/">
                    <FontAwesomeIcon icon={faInstagram} fixedWidth inverse size='lg' />
                  </a>
                  <a href="https://www.mathematica.org/rss">
                    <FontAwesomeIcon icon={faRss} fixedWidth inverse size='lg' />
                  </a>
                </div>
              </Col>
              <Col
                xs={{span: 12, offset: 0}} 
                sm={{span: 12, offset: 0}} 
                md={{span: 1, offset: 0}} 
                lg={{span: 1, offset: 0}}
                >
                <div className="other-links">
                  <span id="extra-links">
                    <a href="https://www.mathematica.org/privacy-policy" className="privacy-policy">Privacy Policy</a>
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row className="footer-divider">
        <Col>
          <Container fluid className="Footer3-divider">
            <Row>
              <Col>
                <div className="horizontal-divider" />
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row className="disclaim-acknowledge-row">
        <Col>
          <Container fluid className="Footer3">
            <Row>
              <Col>
                <div className="discl-ackl-item">
                  <span>
                    <span className="text-bold">Acknowledgements: </span>
                      We thank Drs. Richard Hahn and Jennifer Hill for helpful advice on general principles of how to design an engaging 
                      challenge. We also thank the <a href="https://sci-info.org/"> Society for Causal Inference </a> for hosting the 
                      competition. We enthusiastically acknowledge Erin Lipman (previously at Mathematica, now pursuing 
                      her PhD in statistics at the University of Washington) for contributing both code and big-picture thinking about 
                      longitudinal confounding to our data generating process, and for first-authoring the instructions on this 
                      website. This work is funded by the Department of Health and Human Services, Centers for Medicare &amp; Medicaid 
                      Services under contract HHSM-500-2014-00034I/75FCMC19F0005.
                  </span>
                </div>
                <div className="discl-ackl-item">
                  <span>
                    <span className="text-bold">Disclaimer: </span>
                      The contents of this website and of the simulated datasets are solely the responsibility of the authors and do not 
                      necessarily represent the official views of the U.S. Department of Health and Human Services or any of its agencies.
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </div>
  )
}

export default Footer;